// @flow

import React, { type Node, useCallback, useState } from 'react';
import styled from 'styled-components';
import { getBrandImageSource } from './brands';
import { VerticalAccordion } from '../../../../../commons/organisms/vertical-accordion';
import { Button, Label, Select, Option as SelectOption, Text } from '../../../../../commons/atoms';
import { List, ListItem } from '../../../../../commons/molecules/count-list';

export function PagosnetLocations(): Node {
  return (
    <>
      <Text flavor="display" style={{ fontSize: '1.2em', fontWeight: 600, textAlign: 'center' }}>Instrucciones de pago</Text>
      <Text style={{ textAlign: 'center', marginBottom: '1.5em' }}>Elige abajo tu opción favorita a y vea las instrucciones:</Text>
      <VerticalAccordion initial="efectivo" items={[
        { id: 'efectivo', title: 'Pago en Efectivo', content: <PagoEfectivoBanks /> },
        { id: 'ebanking', title: 'Pago vía Portales E-banking', content: <EBankingBanks /> },
      ]}/>
    </>
  );
}

function PagoEfectivoBanks(): Node {
  return (
    <Root>
      <Text style={{ fontSize: '0.8em', marginBottom: '1em' }}>Presente este cupon en cualquier tienda afiliada de PagosNet:</Text>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {['fassil', 'prodem', 'crecer', 'bcp', 'ecofuturo', 'farmacorp', 'ebisa', 'primera'].map(bankCode => (
          <div key={bankCode} style={{ width: '95px', border: '1px solid #eee', borderRadius: '5px', overflow: 'hidden', margin: '2px' }}>
            <img src={getBrandImageSource(bankCode)} alt={bankCode} style={{ display: 'block', maxWidth: '100%', height: 'auto' }} />
          </div>
        ))}
      </div>
      <LinkButton
        as="a"
        href="http://www.pagosnet.com.bo/geolocalizacion-2017"
        outlineColor="#2397d4"
        rel="noopener noreferrer"
        target="_blank"
        type="transparent"
        style={{ width: '100%' }}
      >
        VER PUNTO DE PAGO MÁS CERCANO
      </LinkButton>
    </Root>
  );
}

function EBankingBanks(): Node {
  const [selectedOption, setSelectedOption] = useState<string>('BCP');
  const onChange = useCallback((event) => {
    setSelectedOption(event.target.value);
  });
  return (
    <Root>
      <Label>Banca en línea</Label>
      <Select onChange={onChange} value={selectedOption}>
        {Object.keys(ebankingOptions).map(key => (
          <SelectOption key={key} value={key}>{key}</SelectOption>
        ))}
      </Select>
      {selectedOption && (
        <List style={{ marginTop: '1em' }}>
          {ebankingOptions[selectedOption].map((content, index) => (
            <ListItem key={index} style={{ color: '#828892' }}>
              {content}
            </ListItem>
          ))}
        </List>
      )}
    </Root>
  );
}

const ebankingOptions = {
  'BCP': [
    'Verificar datos de la cuenta, continuar y seleccionar del panel derecho Pagos.',
    'Seleccionar del panel izquierdo, Pago de Servicios - PAGOSNET',
    'Seleccionar la cuenta de la que se realizará el pago.',
  ],
  'EBISA': [
    'En el panel izquierdo Operaciones de Pago, selecciona Pago de Servicios Online.',
    'Seleccionar PAGOSNET y la cuenta a debitar.',
    'Ingresar los datos a facturar NIT y NOMBRE.',
    'Seleccionar la agencia para el recojo de factura.',
  ],
  'Banco Economico': [
    'Seleccionar la Opción PagosNet, ingresa el código del cliente del servicio y botón consultar.',
    'Selecciona la cuenta de donde se debitará el pago y confirmar.',
  ],
  'Prodem': [
    'Loguearse en el sitio y completar formulario.',
    'En la opción Otros, seleccione el servicio PagosNet y búsqueda por selección de CÓDIGO DE RECAUDACIÓN, ingrese su código y haga clic en continuar.',
    'Seleccionar productos a pagar, la Caja de Ahorro y registre sus datos para facturación.',
    'Verificar y confirmar datos ingresados. Solicite código SMS para confirmar.',
    'Una vez recibido el SMS, ingrese el código en el campo correspondiente.',
  ],
};

const Root = styled.div`
  @media (min-width: 990px) {
    max-width: 75%;
    margin: 0 auto;
  }
`;

const LinkButton = styled(Button)`
  background: white;
  border-radius: 5px;
  color: #2397d4;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 1em;
  width: 60%;
`;
